import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from '../41e3e4ef74b344163f6f9c634823f771533dce8ee2dfa33ad6af214c7fd67517.cfe-internal.js';
import MenuItem from './2ce626f5e7e2c7b2b61e18f5d380e11bc27e0a8d7081b9e8d4d2c68d86b1b0c7.cfe-internal.js';
import ChevronRightIcon from '../../../icons/components/7c1abc076b4bfccb2936ed1ad22a89bc68d713680237e732848398dfb69b6001.cfe-internal.js';

var _excluded = ["label", "className"];
var SubmenuAnchor = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var label = _ref.label,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default.createElement(MenuItem, _extends({
    "aria-haspopup": "menu",
    className: classNames(className, styles.subMenu),
    ref: ref
  }, rest), label, /*#__PURE__*/React__default.createElement(ChevronRightIcon, {
    className: styles.rightIcon,
    "aria-hidden": "true"
  }));
});
var SubmenuAnchor$1 = SubmenuAnchor;

export { SubmenuAnchor$1 as default };
